(function ($) {
    let $cards = $('.card-result');
    let $checkboxes = $(".phonebook-checkboxes");
    let $queryInput = $("#query-phonebook");

    // INIT
    const _init = function (options) {
        _handleEvenements(options);
        _loadQueryArgs();
    };

    const _loadQueryArgs = function () {
        const urlParams = new URLSearchParams(window.location.search);
        const valeurUsage = urlParams.get('usage');

        if (valeurUsage) {
            const $input = $('#' + valeurUsage);
            $input.prop('checked', true);
            _displayCheckedTaxonomies();
            $input.closest('li').toggleClass('active');

        }
    };

    const _truncate = function (str, n) {
        return (str.length > n) ? str.substr(0, n-1) + '...' : str;
    };

    const _slugify = function (str) {
        return str
            .toString()                   // Cast to string (optional)
            .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
            .toLowerCase()                // Convert the string to lowercase letters
            .trim()                       // Remove whitespace from both sides of a string (optional)
            .replace(/\s+/g, '-')         // Replace spaces with -
            .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
            .replace(/\_/g, '-')           // Replace _ with -
            .replace(/\-\-+/g, '-')       // Replace multiple - with single -
            .replace(/\-$/g, '');
    }

    // EVENTS
    const _handleEvenements = function (options) {
        _handleDisplayCheckboxes();
        _handleForm(options);
    };

    // FORM
    const _handleDisplayCheckboxes = function () {
        let $ul = $('.multiple-select');
        $('.widget-item').on('click', function () {
            let $this = $(this);
            let target = $this.attr('data-target');
            $(`#${target}`).addClass('active');
        });

        $(document).mouseup(function (e) {
            $ul.each(function () {
                let $this = $(this);
                if (!$this.is(e.target) && 0 === $this.has(e.target).length) {
                    $this.removeClass('active');
                }
            });
        });

        $('.btn-widget-item, .close-widget-item').on('click', function () {
            let $this = $(this);
            let $parent = $(this).closest('ul.active');
            setTimeout(function () {
                $parent.removeClass('active');
            });
            // Clear button in popup checkboxes
            if ($this.hasClass('btn-widget-item-clear')) {
                _resetCheckboxes($parent.find('.phonebook-checkboxes').filter(':checked'));
            }
        });
    };
    const _getCheckboxes = function () {
        let aTaxonomies = {};
        $checkboxes.filter(':checked').each(function () {
            let $this = $(this);
            if ($this.data('taxonomy') in aTaxonomies) {
                aTaxonomies[$this.data('taxonomy')].push($this.val());
            } else {
                aTaxonomies[$this.data('taxonomy')] = [$this.val()];
            }
        });
        return aTaxonomies;
    };
    const _resetCheckboxes = function ($checkboxes) {
        $checkboxes.trigger('click');
    };
    const _handleForm = function (options) {
        $checkboxes.on('change', function () {
            let $this = $(this);
            _displayCheckedTaxonomies();
            $this.closest('li').toggleClass('active');
            _displayCards();
        });

        $queryInput.on('input', function () {
            _displayCards();
        });
    };
    const _displayCheckedTaxonomies = function () {
        $('.widget-item').each(function () {
            let $this = $(this);
            let aTerms = [];
            let terms = "";
            let $divTaxonomyTitle = $this.find('.taxonomy-title');
            let $divCheckedTaxonomies = $this.find('.checked-taxonomies');
            $this.find('input:checked').each(function () {
                let label = $("label[for='" + $(this).attr('id') + "']").text();
                aTerms.push(label.trim());
            });
            if (aTerms.length > 0) {
                terms = aTerms.join(', ');
                terms = _truncate(terms, 30);
                $divTaxonomyTitle.css('display', 'none');
                $divCheckedTaxonomies.text(terms);
                $divCheckedTaxonomies.css('display', 'block');
            } else {
                $divTaxonomyTitle.css('display', 'block');
                $divCheckedTaxonomies.text('');
                $divCheckedTaxonomies.css('display', 'none');
            }
        });
    };
    const _displayCards = function () {
        let aTaxonomies = _getCheckboxes();
        $cards.parent().show();
        let query = '';
        $cards.each(function () {
            let $this = $(this);
            if (Object.keys(aTaxonomies).length > 0 && $this.attr('data-taxonomies')) {
                let aCardTaxonomies = JSON.parse($this.attr('data-taxonomies'));
                let found = true;
                for (const [key, value] of Object.entries(aTaxonomies)) {
                    found = found && (aCardTaxonomies[key] !== undefined && aCardTaxonomies[key].some(r => value.includes(r)));
                }
                if (!found) {
                    $this.parent().hide();
                }
            }
            // const aProductRefs = JSON.parse($this.attr('data-refs'));
            if (query && !$this.attr('data-title').toLowerCase().includes(query.toLowerCase())) {
                $this.parent().hide();
            }
        });

        $('.card-no-result').toggle($('.card-result:visible').length <= 0);
    };

    const _searchRefInArray = function (query, aRefs) {
        return aRefs.some((reference) =>
            reference.startsWith(query)
        );
    }

    $(document).ready(function () {
        let options = {};
        _init(options);
    });

})(jQuery);


